import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'document',
  type: 'file--document',
  attributes: {
    uuid: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'uuid',
    },
    filename: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'filename',
    },
    data: {
      type: 'string',
      name: 'data',
      required: false,
      isArray: false,
    },
    uri: {
      type: 'string',
      name: 'uri',
      required: false,
      isArray: false,
    },
    /*
    uri: {
      type: {
        value: {
          type: 'string',
          name: 'value',
          required: false,
          isArray: false,
        },
        url: {
          type: 'string',
          name: 'url',
          required: false,
          isArray: false,
        },
      },
      required: false,
      isArray: false,
      name: 'uri',
    }, */
    filemime: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'filemime',
    },
    filesize: {
      type: 'integer',
      required: false,
      isArray: false,
      name: 'filesize',
    },
    created: {
      type: 'integer',
      required: false,
      isArray: false,
      name: 'created',
    },
    change: {
      type: 'integer',
      required: false,
      isArray: false,
      name: 'change',
    },
    url: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'url',
    },
  },
  relationships: {
    user: {
      type: 'user--user',
      required: false,
      isArray: false,
      name: 'uid',
    },
  },
};
export const FileDocumentService = createService(base, configuration, API_CONFIG.API);
export const FileDocumentModule = createModule(FileDocumentService, true);



// WEBPACK FOOTER //
// ./src/models/fileDocument.js